import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SiDialogComponent } from './components/si-dialog/si-dialog.component';
import { SiDialogUserMetaComponent } from './components/si-dialog-user-meta/si-dialog-user-meta.component';
import {
  DialogBodyDirective,
  DialogFooterDirective,
  DialogHeaderMetaDirective,
} from './directives';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
@NgModule({
  imports: [
    DisableAutocompleteDirectiveModule,
    CommonModule,
    FontAwesomeModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressBarModule,
    SiDialogUserMetaComponent,
  ],
  declarations: [
    SiDialogComponent,
    DialogBodyDirective,
    DialogFooterDirective,
    DialogHeaderMetaDirective,
  ],
  exports: [
    SiDialogComponent,
    SiDialogUserMetaComponent,
    DialogBodyDirective,
    DialogFooterDirective,
    DialogHeaderMetaDirective,
    FontAwesomeModule,
    MatDialogModule,
  ],
})
export class SiModalModule {
}
